import React from 'react';
import myImage from './home/logo.png';
import myImage1 from './sfinancials.png';
import myImage2 from './mastercard.png';
import myImage3 from './visa.png';
import myImage4 from './americanexpress.png';
import myImage5 from './discover.png';

const navLinks = [
  { href: '/', label: 'Home' },
  { href: '/about-us', label: 'Company' },
  { href: '/contact', label: 'Contact' },
  { href: '/products', label: 'Products' },
  { href: '/flooring-services', label: 'Services' },
  { href: '/reviews', label: 'Reviews' },
  { href: '/financing', label: 'Financing' },
  { href: '/inspiration', label: 'Inspiration' },
  { href: '/free-estimate', label: 'Request Estimate' },
];

const paymentIcons = [
  { src: myImage1, alt: 'Synchrony Financing' },
  { src: myImage2, alt: 'Mastercard' },
  { src: myImage3, alt: 'Visa' },
  { src: myImage4, alt: 'American Express' },
  { src: myImage5, alt: 'Discover' },
];

function Footer() {
  return (
    <footer className="bg-[#0075ca] text-white">
      <div className="container mx-auto px-4 pt-14 pb-8 lg:px-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-12 lg:gap-8">
          {/* Brand + contact */}
          <div className="lg:col-span-5">
            <a href="/" className="inline-block mb-5">
              <img
                src={myImage}
                alt="PacifiContract"
                className="h-12 md:h-14 w-auto object-contain"
              />
            </a>
            <p className="text-white/85 text-sm leading-relaxed max-w-sm mb-4">
              Quality flooring for homes and businesses serving San Rafael, CA
              and the North Bay.
            </p>
            <div className="space-y-2 text-sm">
              <a
                href="https://www.google.com/maps/search/?api=1&query=9+Jordan+St,+San+Rafael,+CA+94901"
                target="_blank"
                rel="noreferrer"
                className="flex items-start gap-2 text-white/90 hover:text-white no-underline transition-colors"
              >
                <i className="bi bi-geo-alt-fill mt-0.5" />
                <span>9 Jordan St., San Rafael, CA 94901</span>
              </a>
              <a
                href="tel:+14152180103"
                className="flex items-center gap-2 text-white/90 hover:text-white no-underline transition-colors"
              >
                <i className="bi bi-telephone-fill" />
                <span>(415) 218-0103</span>
              </a>
            </div>
            <div className="flex flex-wrap items-center gap-2 mt-5">
              {paymentIcons.map((icon) => (
                <img
                  key={icon.alt}
                  src={icon.src}
                  alt={icon.alt}
                  className="h-7 w-auto rounded bg-white/95 p-0.5 object-contain"
                />
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div className="lg:col-span-4">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white/70 mb-4">
              Quick Links
            </h3>
            <nav className="grid grid-cols-2 gap-x-4 gap-y-2">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-white/90 hover:text-white no-underline transition-colors py-0.5"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Social */}
          <div className="lg:col-span-3">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white/70 mb-4">
              Connect
            </h3>
            <p className="text-sm text-white/80 mb-4 max-w-xs">
              Follow us for project inspiration and store updates.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com/floorcoveringssanrafael/"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center text-white no-underline transition-colors"
              >
                <i className="bi bi-facebook text-lg" />
              </a>
              <a
                href="https://www.yelp.com/biz/pacificontract-san-rafael-4"
                target="_blank"
                rel="noreferrer"
                aria-label="Yelp"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center text-white no-underline transition-colors"
              >
                <i className="bi bi-yelp text-lg" />
              </a>
            </div>
            <a
              href="/free-estimate"
              className="mt-6 inline-flex items-center gap-2 bg-white text-[#0075ca] font-semibold text-sm px-4 py-2.5 rounded-lg no-underline hover:bg-white/90 transition-colors"
            >
              Request an estimate
              <i className="bi bi-arrow-right" />
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/20 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-sm text-white/75 m-0">
            Copyright © {new Date().getFullYear()} PacifiContract. All rights
            reserved.
          </p>
          <a
            href="https://pacificontract.myhelcim.com/hosted/?token=c4982d85a0d5020b3f938b"
            className="text-sm text-white/75 hover:text-white no-underline transition-colors"
          >
            Pay Invoices
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
